import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, modifyCallback, invalidDataCallback) => {

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return data[fieldName];
    }

    const fieldNames = [
      "name",
      "description",
      "recommendation", 
      "quadrantCharacteristics",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {

    const schema = yup.object().shape({
      name: yup.string().max(40).required(),
      description: yup.string().required(),
      recommendation: yup.string().max(40).required(),
      quadrantCharacteristics: yup.string(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    if (await dataIsValid()) {
      modifyCallback(formData);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const formatValue = (value, fieldName) => {
    return value;
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: formatValue(value, fieldName)
    })
  }

  return { formData, setFormValue, submit };
}

export default useHandleForm;